import { Injectable } from '@angular/core';
import { EnvironmentName } from '../types/environment-name';

@Injectable({ providedIn: 'root' })
export class ServiceBaseService {
    public static appInsightsAPIKey = '582dd3ed-7db6-48cf-8ef1-a27ea49acf53'; // Developer insights

    constructor() {}

    public static get getEnvironment(): string {
        // Develop env

        const developEnv = 'dev';
        const developUrlParts: string[] = ['localhost'];

        if (developUrlParts.some((urlPart) => location.origin.includes(urlPart))) {
            return developEnv;
        }

        var countrycode = location.origin.includes('.at')
            ? 'at'
            : location.origin.includes('.ch')
              ? 'ch'
              : 'hu';

        // Master env

        const masterEnv = 'master';
        const masterUrlParts: string[] = ['master'];

        if (masterUrlParts.some((urlPart) => location.origin.includes(urlPart))) {
            return `${masterEnv}_${countrycode}`;
        }

        // Staging env

        const stagingEnv = 'staging';
        const stagingUrlParts: string[] = ['staging', 'shopalditest.roksh.com', 'draft'];

        if (stagingUrlParts.some((urlPart) => location.origin.includes(urlPart))) {
            return `${stagingEnv}_${countrycode}`;
        }

        // Production env

        const productionEnv = 'prod';
        const productionUrlParts: string[] = ['roksh', 'shop.aldi.hu'];

        if (productionUrlParts.some((urlPart) => location.origin.includes(urlPart))) {
            return `${productionEnv}_${countrycode}`;
        }

        return developEnv;
    }

    public static get getEnvironmentName(): EnvironmentName {
        var environment = ServiceBaseService.getEnvironment;

        var environmentName = environment.toUpperCase();

        return EnvironmentName[environmentName as keyof typeof EnvironmentName];
    }

    public static get getLoggerBaseUrl(): string {
        var environmentName = this.getEnvironmentName;

        const newLoggerBaseUrl =
            'https://weshop-logservice-new-g9c6bpdhe3egd2az.westeurope-01.azurewebsites.net/api/logger';
        const masterLoggerBaseUrl =
            'https://weshop-logservice-test.azurewebsites.net/api/logger';
        const devLoggerBaseUrl = 'https://localhost:7237/api/logger';

        if (environmentName === EnvironmentName.DEV) {
            return devLoggerBaseUrl;
        }

        if (this.isStagingOrProductionEnvironment(environmentName)) {
            return newLoggerBaseUrl;
        }

        return masterLoggerBaseUrl;
    }

    public static get getLegacyLoggerBaseUrl(): string {
        return this.isStagingOrProductionEnvironment(this.getEnvironmentName)
            ? 'https://logservice.roksh.com/api/logger'
            : null;
    }

    private static isStagingOrProductionEnvironment(
        environmentName: EnvironmentName
    ): boolean {
        return [
            EnvironmentName.STAGING_HU,
            EnvironmentName.STAGING_AT,
            EnvironmentName.STAGING_CH,
            EnvironmentName.PROD_HU,
            EnvironmentName.PROD_AT,
            EnvironmentName.PROD_CH,
        ].includes(environmentName);
    }

    public static getAppInsightKey(): string {
        // Just the production environments

        if (
            location.origin.includes('https://delivery-manager.roksh') ||
            location.origin.includes('https://www.delivery-manager.roksh')
        ) {
            this.appInsightsAPIKey = 'badb9c90-6849-4d44-9ba9-6edc3ee9173c';
        } else if (
            location.origin.includes('https://provider-manager.roksh') ||
            location.origin.includes('https://www.provider-manager.roksh')
        ) {
            this.appInsightsAPIKey = '3c77a28f-585c-4694-aa47-5f90e6cf0242';
        } else if (location.origin.includes('localhost')) {
            // Developer insights

            this.appInsightsAPIKey = '582dd3ed-7db6-48cf-8ef1-a27ea49acf53';
        }

        return this.appInsightsAPIKey;
    }
}
